module.exports = __webpack_public_path__ + "public/SiteIcons/call.png?f26f83bf";